var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BetaWarning'),_c('v-container',[_c('CategoryForm',{attrs:{"edit":true},on:{"updated":_vm.updatedCategory},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }